import { ICON_TYPES } from './iconTypes';

export default {
	calculator: {
		name: 'calculator',
		type: ICON_TYPES.ionicon,
		text: 'Calculator',
	},
	table: {
		name: 'table',
		type: ICON_TYPES.fontAwesome5,
		text: 'Table',
	},
	readMore: {
		name: 'read-more',
		type: ICON_TYPES.materialIcons,
		text: 'Read More',
	},
	barChart: {
		name: 'bar-chart',
		type: ICON_TYPES.fontAwesome,
		text: 'Bar Chart',
	},
	pieChart: {
		name: 'pie-chart',
		type: ICON_TYPES.fontAwesome,
		text: 'Pie Chart',
	},
	details: {
		name: 'list-alt',
		type: ICON_TYPES.fontAwesome,
		text: 'Details',
	}
};